import {IntermediatePart} from "../../parts/intermediatePart";
import {BathTubType, LayoutType, ShowerComboTubType} from "../../constants";
import {ShowerTubCombo} from "../../parts/showerTubCombo";
import DesignNavigationItem from "../../../../visComponents/designNavigationItem";

export default class BathTubBody extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'bathtub';
    this.partName = 'Bathtub';
    this.translateId = "visualizer.bathroom.bathtub.bathtub";
    this.homePageTitle = 'Bathtubs';
    this.visible = [BathTubType.FreeStanding];
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    // return super.load_(dbFeature, this, false);
    const feature = this.load_(dbFeature, new BathTubBody());
    if (feature) {
      BathTubBody.setAdditionalMetaData(feature);
    }
  }

  static setAdditionalMetaData(feature) {
    if (!feature.metaData["Fixture"]) {
      feature.metaData["Fixture"] = ["All"];
    }
    if (!feature.metaData["CompatibleTub"]) {
      feature.metaData["CompatibleTub"] = ["All"];
    }
  }

  disabledClick() {
    const bathTubFixture = this.getParent().bathTubFixture;
    if (bathTubFixture) {
      bathTubFixture.disabled = this.disabled;
    }
    const bathtubParent = this.getParent();
    if (bathtubParent.layout.type === LayoutType.Small && !this.disabled) {   // switch off all shower features
      const showerBody = bathtubParent.layout.parts.Shower.showerBody;
      if (showerBody) {
        showerBody.disabled = true;
        showerBody.disabledClick();
      }
      const comboPart = bathtubParent.layout.parts[ShowerTubCombo.id];
      if (comboPart) {
        comboPart.showerTubComboIsActive = false;
      }
    }
  }

  handleClick() {
    const bathTubParent = this.getParent().getParent();
    bathTubParent.bathTubType_ = BathTubType.FreeStanding;
    bathTubParent.activeSubType_ = BathTubType.FreeStanding;
    super.handleClick();
  }

  navigationSubItems(filters, searchText) {
    const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
    const featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(), filteredAvailableFeatures);
    return featuresToDisplay.map(_ => new DesignNavigationItem(_.featureName, _));
  }

  setLayers(layout) {
    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())
      || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }

    this.setDefault();
    return super.setLayers(layout);
  }

  getArrayOfConditions() {
    const showerTubCombo = this.getParent().layout.parts[ShowerTubCombo.id];
    const compatibleTubValue = (showerTubCombo.showerTubComboIsActive && showerTubCombo.bottomTub === ShowerComboTubType.walk_in_tub)
      ? ["All"]
      : ["All", "WalkInTub"];
    return [{
      propName: 'CompatibleTub',
      propValue: compatibleTubValue
    }];
  }

  setDefault(layout) {
    const filteredFeatures = this.features.filter(f => f.matchesMetaForArrayOfConditions(this.getArrayOfConditions()));
    if (!super.tryToSetTheSameFeature(filteredFeatures)) {
      const hardCodedDefault = filteredFeatures.find((feature) => {
        return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("Kingston Elegance 258GRA");
      });
      const placeholderDefault = filteredFeatures.find((feature) => {
        return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("laceholder");
      });
      this.activeFeature = hardCodedDefault || super.setDefault(layout) || filteredFeatures[0];
      this.placeholderFeature = placeholderDefault || null;
    }
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.BathTub.FreeStanding.Base;
    }
    if(zIndexes && this.placeholderFeature) {
      this.placeholderFeature.layer.zIndex = zIndexes.BathTub.FreeStanding.Base;
    }
  }
}
